import React, { useEffect } from 'react';
import './App.css';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import Router from 'router/router';
import { withRouter } from 'react-router-dom';
import * as actions from 'redux/actions/index';
import { useDispatch, useSelector } from 'react-redux';

const App = () => {
   let dispatch = useDispatch();
   const { user } = useSelector(state => {
      return state.authReducer
   });

   useEffect(() => {
      if (user) {
         dispatch(actions.userAPI());
      }
   }, []);

   return (
      <>
         <ReactNotification />
         <Router />
      </>
   );
}

export default withRouter(App);
